import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { InputType } from '@rensa/shared/enums/input-type.enum';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css']
})
export class InputComponent implements OnInit, ControlValueAccessor {
  @Input() name: string;
  @Input() type: InputType;
  @Input() error: string;
  @Input() label: string;
  @Input() showLabel = true;
  @Input() disabled = false;
  @Input() step = 5;

  value: boolean = null;

  private fieldType = 'text';

  constructor(@Self() @Optional() private control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showSuccess(): boolean {
    if (!this.control) {
      return false;
    }
    const {dirty, touched} = this.control;
    return !this.control.invalid ? (dirty || touched) : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }
    const {dirty, touched} = this.control;
    return this.invalid ? (dirty || touched) : false;
  }

  onChange: (value: string[]) => void = () => {
  }

  onTouched = () => {
  }

  ngOnInit(): void {
    switch (this.type) {
      case InputType.TEXT:
        this.fieldType = 'text';
        break;
      case InputType.NUMBER:
        this.fieldType = 'number';
        break;
      default:
        this.fieldType = 'text';
    }
  }

  getFieldType(): string {
    return this.fieldType;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any): void {
    this.value = value;
  }
}
